import React from "react";

import { Erc721CollectionDialogForm } from "../../pages/mechanics/marketing/collection/contract/form";
import { CollectionTemplateDialogForm } from "../../pages/mechanics/marketing/collection/template/form";
import { CollectionTokenDialogView } from "../../pages/mechanics/marketing/collection/token/view";
import { CraftDialogForm } from "../../pages/mechanics/gaming/recipes/craft/form";
import { DismantleDialogForm } from "../../pages/mechanics/gaming/recipes/dismantle/form";
import { MergeDialogForm } from "../../pages/mechanics/gaming/recipes/merge/form";
import { AchievementRuleEditDialog } from "../../pages/mechanics/meta/achievements/rule/form";
import { AchievementLevelDialogForm } from "../../pages/mechanics/meta/achievements/levels/form";
import { InviteDialog } from "../../pages/infrastructure/merchant/managers/invite/dialog";

export enum AdminDialogKeys {
  COLLECTIONS_CONTRACT_EDIT = "collectionContractEdit",
  COLLECTIONS_TEMPLATE_CREATE = "collectionTemplateCreate",
  COLLECTIONS_TEMPLATE_EDIT = "collectionTemplateEdit",
  COLLECTIONS_TOKEN_VIEW = "collectionTokenView",

  CRAFT_CREATE = "craftCreate",
  CRAFT_EDIT = "craftEdit",

  DISMANTLE_CREATE = "dismantleCreate",
  DISMANTLE_EDIT = "dismantleEdit",

  MERGE_CREATE = "mergeCreate",
  MERGE_EDIT = "mergeEdit",

  ACHIEVEMENT_RULE_CREATE = "achievementRuleCreate",
  ACHIEVEMENT_RULE_EDIT = "achievementRuleEdit",

  ACHIEVEMENT_LEVEL_CREATE = "achievementLevelCreate",
  ACHIEVEMENT_LEVEL_EDIT = "achievementLevelEdit",

  MANAGERS_INVITE = "managersInvite",
}

export const adminGlobalDialogComponentsSchema = {
  [AdminDialogKeys.COLLECTIONS_CONTRACT_EDIT]: Erc721CollectionDialogForm,
  [AdminDialogKeys.COLLECTIONS_TEMPLATE_CREATE]: CollectionTemplateDialogForm,
  [AdminDialogKeys.COLLECTIONS_TEMPLATE_EDIT]: CollectionTemplateDialogForm,
  [AdminDialogKeys.COLLECTIONS_TOKEN_VIEW]: CollectionTokenDialogView,

  [AdminDialogKeys.CRAFT_CREATE]: CraftDialogForm,
  [AdminDialogKeys.CRAFT_EDIT]: CraftDialogForm,

  [AdminDialogKeys.DISMANTLE_CREATE]: DismantleDialogForm,
  [AdminDialogKeys.DISMANTLE_EDIT]: DismantleDialogForm,

  [AdminDialogKeys.MERGE_CREATE]: MergeDialogForm,
  [AdminDialogKeys.MERGE_EDIT]: MergeDialogForm,

  [AdminDialogKeys.ACHIEVEMENT_RULE_CREATE]: AchievementRuleEditDialog,
  [AdminDialogKeys.ACHIEVEMENT_RULE_EDIT]: AchievementRuleEditDialog,

  [AdminDialogKeys.ACHIEVEMENT_LEVEL_CREATE]: AchievementLevelDialogForm,
  [AdminDialogKeys.ACHIEVEMENT_LEVEL_EDIT]: AchievementLevelDialogForm,

  [AdminDialogKeys.MANAGERS_INVITE]: InviteDialog,
} as const satisfies Record<AdminDialogKeys, React.ComponentType<any>>;
